// @ts-nocheck

import { createSelector } from 'reselect';

import { type Selector } from '../../../../types/selectors';
import { selectBoomGlobalStatus } from '../../selectors/global/globalPrimary.selector';
import { BoomGlobalStatuses } from '../../types/global';

export const selectBoomIsDisabled: Selector<boolean> = createSelector(
  [selectBoomGlobalStatus],
  (globalStatus) => globalStatus === BoomGlobalStatuses.ENDING,
);
